import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: '100%',
    padding: '1.5rem',
  },
}));

export default useStyles;
